<ion-content id="main-content" class="full-width-page">
    <div class="bg-theme-alt">
        <div class="bg-grad-special">
            <div class="bg-grad-special-alt">
                <div class="nk-ovm shape-u shape-contain shape-left-top"></div>
                <app-header></app-header>
                <section class="section bg-theme tc-light animated fadeInUp" data-animate="fadeInUp" data-delay="0.4"
                    style="visibility: visible; animation-delay: 0.4s;">
                    <div class="container">
                        <div class="nk-block nk-block-features-s2">
                            <div class="row align-items-center gutter-vr-30px">
                                <div class="col-md-6">
                                    <img src="./assets/images/custom-hiddin/ecosystem.png" alt="ecosystem">
                                </div>
                                <div class="col-md-6">
                                    <div class="nk-block-text">
                                        <h6 class="title title-xs title-s1 tc-primary">Empowering Schools with Secure
                                            Funding, Communication, and Operations</h6>
                                        <p>
                                            The school gets general fund contributions from participating students and
                                            the first twelve participants that each student signs up with our enhanced
                                            communication services. The school will be able to securely communicate with
                                            students and enrolled alumni with both our fee and free communication
                                            services for as long as this technology remains viable. The school will be
                                            able to accept payments from participants with accumulations in their
                                            personal health and education credits for tuition and related school
                                            expenses. Sponsoring schools will be appointing members to the board of
                                            directors of the tuition reimbursement endowment to decide how the school
                                            will disburse the earnings from these tuition reimbursement endowments. In
                                            phase II the school, working with its IT and accounting personnel, will
                                            redesign their operations with a license of our tech to make their internal
                                            operations secure.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section class="section bg-theme tc-light">
                    <div class="container">
                        <div class="nk-block nk-block-features-s2">
                            <div class="row align-items-center gutter-vr-30px">
                                <div class="col-md-6">
                                    <div class="nk-block-text">
                                        <h6 class="title title-xs title-s1 tc-primary">Connecting Students to Secure
                                            Communication and Marketplace Opportunities</h6>
                                        <p>
                                            Students and everyone they sign up and everyone they sign up with our
                                            services will be given a three-month free trial of our $45 a month enhanced
                                            communication services that they can then convert to our free basic
                                            communication services. Everyone signing up will be automatically enrolled
                                            in the HIDDIN Marketplace as buyers when we bring those services online.
                                            Buyer participation is always free. Sellers have their own enrollment
                                            process, and they will be charged commissions based on their industry’s
                                            traditional marketing and advertising expenditures.
                                        </p>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <img src="./assets/images/custom-hiddin/services.png" alt="gfx">
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section class="section bg-theme tc-light">
                    <div class="container">
                        <div class="nk-block nk-block-features-s2">
                            <div class="row align-items-center gutter-vr-30px">
                                <div class="col-md-6">
                                    <img src="./assets/images/custom-hiddin/secured-transaction.png"
                                        alt="Secured Transaction">
                                </div>
                                <div class="col-md-6">
                                    <div class="nk-block-text">
                                        <h6 class="title title-xs title-s1 tc-primary">Building a Self-Sustaining
                                            Ecosystem for Students, Schools, and HIDDIN</h6>
                                        <p>
                                            The student in level 0 and the twelve people we ask them to sign up in level
                                            1 will likely have the greatest association with the school and a large part
                                            of those fees go to support the school’s general fund each month with the
                                            remainder going to support the HIDDIN platform, the HIDDIN direct sales team
                                            working with this school, and the student’s fee commissions which funds
                                            their $45 enhanced communication service fee and contributes to the federal
                                            withholding on their fee commission income after two of their twelve pay $45
                                            each for our enhanced communication services. Level 2 and above see HIDDIN
                                            service fees held at 30%, Participant’s Fee Commissions held at 10%, Tuition
                                            Reimbursement Endowment contributions coming in and holding at 5%,
                                            Participant’s Health & Education Credits coming in and holding at 25% and
                                            Participant’s Fee Endowment coming in and holding at 30%.
                                        </p>
                                        <p>
                                            Participant’s Fee Commissions covers the $45 Fees of the person that signed
                                            the 12 people up in that level and the contributions to that person’s
                                            federal withholding on that income. The first two sign ups paying for
                                            enhanced communication services cover that participant’s $45 fee.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section class="section bg-theme tc-light">
                    <div class="container">
                        <div class="nk-block nk-block-features-s2">
                            <div class="row align-items-center gutter-vr-30px">
                                <div class="col-md-6">
                                    <div class="nk-block-text">
                                        <h6 class="title title-xs title-s1 tc-primary">Funding the Future: Tuition
                                            Reimbursement and Education Credit Programs</h6>
                                        <p>
                                            The Tuition Reimbursement Endowment starts accumulating a percentage of
                                            funding out of the amounts collected after the first two enhanced
                                            communication signups. The board of directors appointed by the sponsoring
                                            private school decides how the endowment income will be used to reimburse
                                            students for tuition they paid previously. The idea is to help reduce the
                                            cost of private schools to make it more affordable without diminishing the
                                            quality of the services provided by the school. It will take many years for
                                            these annual income levels to rise to the point that they will make a
                                            difference but in several decades they could become substantial.
                                        </p>
                                        <p>
                                            Participant’s Health & Education Credits start accumulating after the first
                                            two enhanced communication signups and are available for the participant to
                                            spend on the HIDDIN Marketplace with authorized health and education
                                            providers. We will seek a tax determination letter with the IRS to establish
                                            that the funding into these accounts is nontaxable and that any
                                            disbursements from it are taxable to the participant. These funds are
                                            restricted to paying for authorized health and education expenses for the
                                            participant and immediate family members. They are voided if attempted to be
                                            sold or used to satisfy debts that are not associated with authorized health
                                            and education providers.
                                        </p>
                                    </div>
                                </div>
                                <div class="col-md-6" style="display: flex;justify-content: center;">
                                    <img src="./assets/images/custom-hiddin/layout.png" alt="gfx">
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section class="section bg-theme tc-light">
                    <div class="container">
                        <div class="nk-block nk-block-features-s2">
                            <div class="row align-items-center gutter-vr-30px">
                                <div class="col-md-6">
                                    <img src="./assets/images/custom-hiddin/binary-data.png" alt="gfx">
                                </div>
                                <div class="col-md-6">
                                    <div class="nk-block-text">
                                        <h6 class="title title-xs title-s1 tc-primary">Building Perpetual Funding
                                            Through the Participant’s Fee Endowment</h6>
                                        <p>
                                            Participant’s Fee Endowment collects a percentage of funding after the first
                                            two enhanced communication signups. The idea is to collect enough funds to
                                            earn an amount equivalent to the participants monthly $45 fee. The amount of
                                            $10,800 earning a five percent return would produce a monthly amount of $45
                                            equal to the participants monthly fee requirement which would effectively
                                            guarantee the payment of this participant’s fee into perpetuity. It would
                                            take more than seven years for this endowment to accumulate the required
                                            $10,800 and that would reach the average life expectancy of most
                                            technologies. Throughout this time span participant commissions and any
                                            supplementary payments by the participant would have been required to
                                            maintain this account active. In situations creating a surplus of
                                            Participant Fees from commissions and the endowment above the required $45
                                            the balance goes first to reaching the Participant’s $10,800 target and then
                                            gets paid forward to this Participant’s first signup to fund their $10,800
                                            target then the next of this Participant’s 12 signups until all are over
                                            their $10,800 targets. Then any surpluses are used to fund the $10,800
                                            targets of any adjacent Participant’s 12 signups before funding any level of
                                            additional funding for this Participant.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section class="section bg-theme tc-light">
                    <div class="container">
                        <div class="nk-block nk-block-features-s2">
                            <div class="row align-items-center gutter-vr-30px">
                                <div class="col-md-6">
                                    <div class="nk-block-text">
                                        <h6 class="title title-xs title-s1 tc-primary">Keeping Participants Connected
                                            While Creating Investor Opportunities</h6>
                                        <p>
                                            The enrollment process allows the Participant to identify the intended
                                            beneficiary of their account if they pay for enhanced communication
                                            services.
                                        </p>
                                        <p>
                                            When a Participant chooses not to pay the $45 enhanced communication
                                            services fee after the three-month free trial investors can take over the
                                            $45 payments giving the Participant enhanced communication services for as
                                            long as those fees are paid. The investor earns the Participant’s
                                            Commissions, gets the Tuition Reimbursement Endowment tax deduction, the
                                            Participant’s Fee Endowment and the Participant’s Health & Education
                                            Credits. The original Participant gets credit for all their signups and for
                                            enhanced communication services when determining their share of the 40%
                                            marketplace savings and the investor is allowed to sell the Participant’s
                                            Health & Education Credits to make a profit.
                                        </p>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <img src="./assets/images/custom-hiddin/connect.png" alt="gfx">
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section class="section bg-theme tc-light">
                    <div class="container">
                        <div class="nk-block nk-block-features-s2">
                            <div class="row align-items-center gutter-vr-30px">
                                <div class="col-md-6">
                                    <img class="height450" src="./assets/images/custom-hiddin/shield.png" alt="gfx">
                                </div>
                                <div class="col-md-6">
                                    <div class="nk-block-text">
                                        <h6 class="title title-xs title-s1 tc-primary">Empowering People, Businesses,
                                            and Governments with Permanent Quantum-Proof Protection</h6>
                                        <p>
                                            Students and individuals that sign up enjoy the permanent protections of our
                                            communication and marketplace technologies, as customers of our marketplace
                                            get a share of the 40% savings from the traditional marketing and
                                            advertising spend, get to share our technologies with those they want to
                                            securely communicate and do business with helping them to avoid becoming
                                            cybercrime victims or cyberwarfare casualties.
                                        </p>
                                        <p>
                                            Businesses and governmental divisions that sign up their employees give them
                                            the permanent protections of our communication and marketplace technologies
                                            for both their roles as individuals and employees representing their
                                            organizations in their digital interactions with other enrolled individuals,
                                            businesses, and governmental entities. Encouraging their customers and
                                            citizens to join our marketplace and communication platform permanently
                                            protects them and helps them avoid economic damages, lawsuit expenses and
                                            becoming cybercrime victims or cyberwarfare casualties.
                                            Businesses benefit from the competitive advantages that our technologies
                                            make possible and from their share of the 40% marketing and advertising
                                            expenditure, and in phase II get to overhaul their internal information
                                            systems licensing our secure technologies.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <app-footer></app-footer>
            </div>
        </div>
    </div>
</ion-content>